export const AUTH_STORAGE_KEYS = {
  TOKEN: 'auth_token',
  REFRESH_TOKEN: 'auth_refresh_token',
} as const

export const SESSION_STORAGE_KEYS = {
  // Set while the OTP screen is open. Finding it on mount means the page was
  // reloaded mid-OTP, so VerifyOtpContainer sends the user back to login.
  OTP_VERIFICATION_IN_PROGRESS: 'otp_verification_in_progress',
} as const
